// eslint-disable-next-line check-file/filename-blocklist
export enum MobilePageTypes {
    Unknown = -1,
    Home = 9000,
    Search = 9001,
    Details = 9002,
    Login = 200127,
    BookingForm1 = 9004,
    BookingForm2 = 9005,
    ThankYou = 9006,
    PageNotFound = 9107,
    City = 9009,
    Country = 9010,
    Area = 9011,
    Region = 9012,
}
